import { LOCALES } from '../constants';

const UNSUPPORTED_LOCALES = [LOCALES.HE];

/**
 * Returns the appropriate pricing URL based on the current locale
 * @param locale - The current locale (e.g., 'en', 'de', 'fr')
 * @returns The localized pricing URL
 */
export const getPricingUrl = (locale?: string): string => {
  const unSupportedLocales = Object.values(UNSUPPORTED_LOCALES).includes(locale as keyof typeof LOCALES);

  // If it's English or no locale provided, use the default URL
  if (!locale || unSupportedLocales || locale === LOCALES.EN) {
    return 'https://www.wix.com/plans';
  }

  // Map the locale to the appropriate Wix domain prefix
  return `https://${locale}.wix.com/premium-purchase-plan/dynamo`;
};
